import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { EventBus } from '@catawiki/runtime-toolkit';
import { Button } from '@catawiki/cata-style';

import { lotSubmissionRoutes } from '@/shared/constants/routes';
import { useLocale } from '@/shared/hooks/useLocale';

import styles from './StartSellingButton.module.scss';

type StartSellingButtonProps = {
  isLoggedIn: boolean;
  text?: string;
};

export const StartSellingButton = ({
  isLoggedIn,
  text,
}: StartSellingButtonProps) => {
  const { t } = useTranslation();
  const { isoLocale } = useLocale();

  const router = useRouter();
  return (
    <Button
      className={classNames(styles.startSellingButton, 'u-m-t-xl u-width-full')}
      onClick={() => {
        if (isLoggedIn) {
          router.push(lotSubmissionRoutes.lotCreationPage(isoLocale));
        } else {
          EventBus.showScreen({ screen: EventBus.Screen.SIGN_IN });
        }
      }}
    >
      {text || t('seller_register.cta')}
    </Button>
  );
};
